import { useModel as _useModel, mergeModels as _mergeModels, defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "text-center" }
const _hoisted_2 = { class: "mt-2 flex text-sm/6 text-gray-600" }
const _hoisted_3 = {
  for: "file-upload",
  class: "relative cursor-pointer rounded-md bg-white font-semibold text-indigo-600 focus-within:ring-2 focus-within:ring-indigo-600 focus-within:ring-offset-2 focus-within:outline-hidden hover:text-indigo-500"
}
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { key: 1 }
const _hoisted_6 = {
  key: 0,
  class: "pl-1"
}
const _hoisted_7 = {
  key: 0,
  class: "text-xs/5 text-gray-600"
}

import { watch } from 'vue'
import { PhotoIcon } from '@heroicons/vue/24/solid'


export default /*@__PURE__*/_defineComponent({
  __name: 'FormFileDragAndDrop',
  props: /*@__PURE__*/_mergeModels({
    maxSize: {}
  }, {
    "modelValue": {
  default: null
},
    "modelModifiers": {},
  }),
  emits: ["update:modelValue"],
  setup(__props: any) {

const selectedFile = _useModel<File|null>(__props, "modelValue");



function onChange(event: any): void {
  if (event.target.files == null) return;

  if (event.target.files.length >= 2) {
    alert("Cannot upload more then 1 file");

    return;
  }

  updateFile(event.target.files[0]);
}

function onDragOver(event: DragEvent): void {
  event.preventDefault();
}

function onDrop(event: DragEvent): void {
  event.preventDefault();

  if (event.dataTransfer == null) return;

  if (event.dataTransfer.files.length >= 2) {
    alert("Cannot upload more then 1 file");

    return;
  }

  updateFile(event.dataTransfer.files[0]);
}

function updateFile(file: File): void {
  const allowedSize = __props.maxSize * 1024 * 1024;

  if (file.size >= allowedSize) {
    alert(`File size has to be below ${allowedSize}mb!`);

    return;
  }

  if (file.type !== "application/pdf") {
    alert("Only .PDF files are allowed!");

    return;
  }

  selectedFile.value = file;
}

watch(selectedFile, (newVal, _) => selectedFile.value = newVal);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    onDragover: onDragOver,
    onDrop: onDrop,
    class: "mt-2 flex justify-center rounded-lg border-2 border-dashed border-gray-900/25 px-6 py-4"
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_unref(PhotoIcon), { class: "mx-auto size-12 text-gray-300" }),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("label", _hoisted_3, [
          (selectedFile.value)
            ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(selectedFile.value.name), 1))
            : (_openBlock(), _createElementBlock("span", _hoisted_5, "Upload een bestand")),
          _createElementVNode("input", {
            id: "file-upload",
            type: "file",
            class: "hidden",
            onChange: onChange,
            accept: ".pdf"
          }, null, 32)
        ]),
        (!selectedFile.value)
          ? (_openBlock(), _createElementBlock("p", _hoisted_6, "of sleep en zet het hier neer"))
          : _createCommentVNode("", true)
      ]),
      (!selectedFile.value)
        ? (_openBlock(), _createElementBlock("p", _hoisted_7, "Alleen PDF bestanden, maximaal " + _toDisplayString(_ctx.maxSize) + "MB", 1))
        : _createCommentVNode("", true)
    ])
  ], 32))
}
}

})